import React, { FC, ReactElement } from 'react';
import styled from 'styled-components';
import { up } from 'styled-breakpoints';
import { Course, Recents, Collection } from '@fenderdigital/api-definitions/play';
import { FlatCoursesProgressMap, FlatLessonsProgressMap } from '../../../utils/my-progress-utils';
import { ProgressListViewType } from '../ProgressListViewType';
import { MarkCompleteData } from '../../MarkComplete/MarkComplete';
import PathCard from '../PathCard';
import { getPercentCompleted } from '../progress-list-utils';

interface CourseListProps {
  courses: Course[];
  collection?: Collection;
  coursesProgress: FlatCoursesProgressMap;
  lessonProgress: FlatLessonsProgressMap;
  recentlyViewed?: { [key: number]: Recents };
  loggedIn?: boolean;
  url: string;
  view: ProgressListViewType;
  markCompleteData?: MarkCompleteData;
}

interface ProgressLayoutWrapperProps {
  isCourseDetail?: boolean | null;
}

const Container = styled.div<ProgressLayoutWrapperProps>`
  padding: 0px 1rem;
  margin: auto auto 2rem auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: transparent;
  list-style-type: none;

  ${up('tablet-portrait')} {
    padding: 0px 2rem;
    justify-content: flex-start;
  }
`;

const CourseList: FC<CourseListProps> = ({
  courses,
  collection,
  coursesProgress,
  lessonProgress,
  recentlyViewed,
  loggedIn,
  url,
  view,
  markCompleteData,
}) => {
  return (
    <Container data-id="progress-list">
      {courses?.map(
        (courseData: Course, courseIndex: number): ReactElement => {
          const { id, lessons, slug } = courseData;
          const courseIsMarkedComplete = coursesProgress[id]?.completed ?? false;
          const percentCompleted = courseIsMarkedComplete
            ? 1
            : getPercentCompleted(lessons, lessonProgress);
          const { 'course-id': recentlyViewedCourseId } = recentlyViewed?.[0] || {};
          const indexOfCourse = courseIndex + 1;
          const recentlyViewedCourse = recentlyViewedCourseId === id;
          const routeBase = loggedIn ? 'course' : 'courses';
          const toURL = `${loggedIn ? url : ''}${
            url.indexOf('course') < 0 || view === 'collectionDetail' ? `/${routeBase}/${slug}` : ''
          }`;
          return (
            <PathCard
              collectionId={collection?.id}
              collectionTitle={collection?.title}
              courseData={courseData}
              courseNumber={indexOfCourse ?? 0}
              recentlyViewedCourse={recentlyViewedCourse}
              percentCompleted={percentCompleted ?? 0}
              markCompleteData={markCompleteData}
              toURL={toURL}
              key={id}
            />
          );
        },
      )}
    </Container>
  );
};

export default CourseList;
